import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

// Connects to data-controller="time-dropdown"
export default class extends Controller {
  static targets = ["frame", "input", "value"];
  static values = { timeId: String };

  connect() {
    useClickOutside(this, {
      onlyVisible: true,
    });
  }

  search() {
    const params = new URLSearchParams({
      time_id: this.timeIdValue,
      q: this.inputTarget.value,
      selected: this.valueTarget.value,
    });
    this.frameTarget.src = `/admin/time?${params.toString()}`;

    if (this.inputTarget.value == "") {
      this.valueTarget.value = "";
      this.show();
    }
  }

  isOpen() {
    return this.frameTarget.hidden == false;
  }

  select({ params }) {
    this.valueTarget.value = params.value;
    this.inputTarget.value = params.label;
    this.hide();
  }

  setAndHide() {
    if (this.inputTarget.value == "") {
      this.valueTarget.value = "";
    } else {
      const selected = this.element.querySelector("[data-selected]");
      if (selected) {
        this.inputTarget.value = selected.dataset.label;
        this.valueTarget.value = selected.dataset.value;
      }
    }
    this.hide();
  }

  selectText() {
    this.inputTarget.select();
  }

  confirm(event) {
    if (this.isOpen()) {
      event.preventDefault();
    }
    this.setAndHide();
  }

  show() {
    this.frameTarget.hidden = false;
    this.inputTarget.setAttribute("aria-expanded", "true");
  }

  hide() {
    this.frameTarget.hidden = true;
    this.inputTarget.setAttribute("aria-expanded", "false");
  }

  clickOutside(event) {
    this.hide();
  }
}
